<template>
    <div class="container">
    <div class="columns">
        <div class="column col-7 col-mx-auto">
            <h1>Account & Payment settings <small class="label"></small></h1>

            <form class="form-horizontal" action="#forms" style="padding: 20px">
              <div class="form-group">
                <div class="col-3 col-sm-12">
                  <label class="form-label" for="input-example-4">E-mail</label>
                </div>
                <div class="col-9 col-sm-12">
                  <input class="form-input" type="email" id="input-example-4" placeholder="E-mail" autocomplete="off">
                </div>
              </div>
              <div class="form-group">
                <div class="col-3 col-sm-12">
                  <label class="form-label" for="input-example-4">Password</label>
                </div>
                <div class="col-9 col-sm-12">
                  <input class="form-input" type="password" id="input-example-4" placeholder="Password" autocomplete="off">
                </div>
              </div>
              <div class="form-group">
                <div class="col-3 col-sm-12">
                  <label class="form-label" for="input-example-4">Re-type password</label>
                </div>
                <div class="col-9 col-sm-12">
                  <input class="form-input" type="password" id="input-example-4" placeholder="Your password again" autocomplete="off">
                </div>
              </div>
            </form>


<table class="table table-striped table-hover">
  <thead>
    <tr>
      <th>Invoice</th>
      <th>Amount</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr class="active">
      <td>The Shawshank Redemption</td>
      <td>Crime, Drama</td>
      <td>14 October 1994</td>
    </tr>
  </tbody>
</table>

        </div>
    </div>
    </div>
</template>

<script>
export default {
  name: 'acount-page-index',
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/AccountPage.vue